import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useMakePrimary(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const makePrimary = (athleteId: string): Promise<AxiosResponse<null>> => {
    return client.put(`athletes/${athleteId}/make-primary/`);
  };

  return useMutation(makePrimary, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['connectedAthletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['paymentMethods'],
      });
    },
  });
}
